import { format, isValid, parse, parseISO } from 'date-fns'
import { formatInTimeZone, fromZonedTime, toZonedTime } from 'date-fns-tz'

export const parseDate = (date: any, dateStringFormat?: string): Date | null => {
  try {
    if (dateStringFormat) {
      return parse(date, dateStringFormat, new Date())
    } else {
      return parseISO(date)
    }
  } catch (e) {
    return null
  }
}

export const formatDate = (date: any, dateStringFormat: string): string | null => {
  try {
    return format(date, dateStringFormat)
  } catch (e) {
    return null
  }
}

export const compareDates = (a: string = '', b: string = '') => {
  return new Date(b).valueOf() - new Date(a).valueOf()
}

export function getFormatedTime(time?: string) {
  if (time && isValid(parse(time, 'HH:mm:ss', new Date()))) {
    return format(new Date(`July 1, 1999,${time}`), 'hh:mm a')
  }
  return 'N/A'
}

export const getPlannerTime = (datetime: string | null, stringFormat = 'h:mmaaa zzz') => {
  // api sends back planner times in UTC with explicit Z appended
  // display time in local/system time
  if (datetime) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    try {
      return formatInTimeZone(datetime, timezone, stringFormat)
    } catch (e) {
      return 'Invalid  Date'
    }
  } else {
    return null
  }
}

export const getPlannerTimeRange = (startTime: string | null | undefined, endTime: string | null | undefined) => {
  if (startTime && endTime) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    try {
      const start = formatInTimeZone(startTime, timezone, 'h:mmaaa')
      const end = formatInTimeZone(endTime, timezone, 'h:mmaaa zzz')
      return `${start} - ${end}`
    } catch (e) {
      return 'Invalid  Date'
    }
  } else {
    return null
  }
}

export const convertUtcToLocalTime = (datetime: string | Date) => {
  if (datetime) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    try {
      return toZonedTime(datetime, timezone)
    } catch (e) {
      return ''
    }
  } else {
    return ''
  }
}

export const convertLocalTimeToUtc = (datetime: string): Date => {
  // convert datetime from local time to utc time for api
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const utcDatetime = fromZonedTime(datetime, timezone)
  return utcDatetime
}

export const getJobStartTime = (startsAt: string | undefined, timezone: string | undefined): string | null => {
  // time is UTC from backend, but string doesn't include Z (utc) identifier
  // manually add Z to work with date-fns-tz
  const utcStartsAt = `${startsAt}Z`
  if (startsAt && timezone) {
    try {
      return formatInTimeZone(utcStartsAt, timezone, 'h:mmaaa zzz')
    } catch (e) {
      return 'Invalid Date'
    }
  } else {
    return null
  }
}
